export const scheduleKeys = {
  saveToDevice: "saveToDevice",
  removeFromDevice: "removeFromDevice",
  enableSchedule: "enableSchedule",
  disableSchedule: "disableSchedule",
};

export const scheduleLabel = {
  saveToDevice: "Save to Device",
  removeFromDevice: "Remove from Device",
  enableSchedule: "Enable Schedule",
  disableSchedule: "Disable Schedule",
};

export const fleetSchdData = "fleetSchdData";

export const schdState = {
  enable: "Enabled",
  disable: "Disabled",
};

export const fleetStatus = {
  notInitiate: "notInitiate",
  Disabled: "Disabled",
  NA: "NA",
  Completed: "Completed",
  Failed: "Failed",
  Timeout: "Timeout",
  InProgress: "InProgress",
};

// Get Data from localstorage
export const getLocalData = () =>
  JSON.parse(localStorage.getItem(fleetSchdData)) || [];

// Find index with site id
export const findDataIndexFromLocal = (siteId) =>
  getLocalData().findIndex((ele) => ele.siteId === siteId);

// Generic function to update localstorage
export const initStates = {
  status: fleetStatus.notInitiate,
  fleetId: "",
  action: "",
  deviceListIds: [],
  processedList:[],
  templateData: {},
  isOpenFleetPanel: false,
  schdState: schdState.disable,
};
export const updateLocalStorageData = (updateData, siteId) => {
  let init = {
    siteId: siteId,
    ...initStates,
  };
  let localData = getLocalData();
  let idx = findDataIndexFromLocal(siteId);

  if (idx !== -1) {
    localData[idx] = { ...localData[idx], ...updateData };
  } else {
    localData.push({ ...init });
  }

  localStorage.setItem(fleetSchdData, JSON.stringify(localData));
};

// Get current site local data
export const getCurrentSiteLocalData = (siteId) => {
  let dataIndex = findDataIndexFromLocal(siteId);
  return dataIndex !== -1 ? getLocalData()[dataIndex] : {};
};
